import 'react-app-polyfill/ie9'; // For IE 9-11 support
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { Provider } from "react-redux";
import { store, persistor } from "./redux/store";
import { PersistGate } from "redux-persist/integration/react";
// import GlobalErrorBoundary from './GlobalErrorBoundary';
ReactDOM.render(
    <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
            {/* <GlobalErrorBoundary> */}
                <App />
            {/* </GlobalErrorBoundary> */}
        </PersistGate >
    </Provider >,
    document.getElementById('root')
);

window.onerror = (message, source, lineno, colno, error) => {
    console.log("Global Error Caught: ", { message, source, lineno, colno, error });
    // logErrorToCloudwatch("UNCAUGHT_ERROR", { message, source, lineno, colno, error });
};

window.onunhandledrejection = (event) => {
      console.log("Global Error Caught 11: ", event );
    // logErrorToCloudwatch("UNHANDLED_PROMISE", { reason: event.reason });
  };

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();